import { UAParser } from 'ua-parser-js';
function getUserAgentAttributes() {
  const {
    browser: {
      name: browserName,
      version: browserVersion
    },
    device: {
      type: deviceType,
      model: deviceModel,
      vendor: deviceVendor
    },
    engine: {
      name: engineName,
      version: engineVersion
    },
    os: {
      name: osName,
      version: osVersion
    }
  } = new UAParser().getResult();
  const userAgentAttributes = {
    browserName,
    browserVersion,
    deviceType,
    deviceModel,
    deviceVendor,
    engineName,
    engineVersion,
    osName,
    osVersion
  };
  return userAgentAttributes;
}
export default getUserAgentAttributes;